import Vue from 'vue';
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import cnLocale from 'element-ui/lib/locale/lang/zh-CN'
import ruLocale from 'element-ui/lib/locale/lang/ru-RU'


import cn from './config/cn';
import en from './config/en';
import ru from './config/ru';

Vue.use(VueI18n);

const messages = {
    cn: Object.assign(cn, cnLocale),
    en: Object.assign(en, enLocale),
    ru: Object.assign(ru, ruLocale),
}
console.log(sessionStorage.getItem('lang'))
const i18n = new VueI18n({
    locale: sessionStorage.getItem('lang') || 'cn',
    messages,
    silentTranslationWarn: true, // 去除国际化警告
});


export default i18n;